export const ASC = 'asc'
export const DESC = 'desc'
export const NO_SORT = ''

export const ACTIVE = 'active'
export const INACTIVE = 'inactive'
